// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import addressValidationFactory from '../common/AddressValidation.js';
import { handleDisplayFor, setElementsFromScope, setDisabled, setOptionsForSelect } from "../../utilities/selectorHelpers";
import { createPreventDefault, isPresent, formatPhone } from '../../utilities/general';
import { instantiateSelect2 } from "../../utilities/select2able";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import EditChecker from '../../components/EditChecker/EditChecker';
import { setSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
import { isNull, isNullOrUndefined, isNumber } from 'util';
import timePicker from '../../components/timePicker/timePicker';
import datePicker from '../../utilities/datePicker/index.js'
const modalHtml = require('../../sharedHtml/modal.html');
require("./html/dockNewEdit/dockNewEdit.less");

// Additional Imports...

//const dayShiftRowHtml = require('./html/dayShiftRow.html');
const newShiftHtml = require('./html/dockNewEdit/html/newShift.html');
const newAddDoorHtml = require('./html/dockNewEdit/html/addDoor.html');
const dockNewEditHtml =require('./html/dockNewEdit/html/dockNewEdit.html');
const dockEditHtml = require('./html/dockNewEdit/html/dockEdit.html');

const targetSelector = "#dock-details";


//const mainEl = $(mainHtml);

run(targetSelector, (mainEl)=>{
  dockConfigDetails(mainEl);
});

function dockConfigDetails(mainEl){


  const activateDock = mainEl.data("activate-dock-msg");
  const activateDockBtn = mainEl.data("activate-dock-msg");
  const deactivateDockBtn = mainEl.data("deactivate-dock-msg");
  const deactivateDock = mainEl.data("deactivate-dock-msg") ;
  const pageRefreshUrl=mainEl.data("page-refresh-url");
  const dockId = mainEl.data("dock-id");
   const deleteItemUrl =  mainEl.data("delete-item-url");

  let activateDiv = render('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
            activateMsg: mainEl.data("activate-dock-txt-msg")
        }
    );
    let deactivateDiv = render('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
        deactivateMsg: mainEl.data("deactivate-dock-txt-msg")
        }
    );
 
  //Validate the Form 
  function validateForm(formElement) {
    let validator, validationOpts; 
    validationOpts = {
      debug: true,
      errorPlacement: function (error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    }
    validator = formElement.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";

    if (formElement.valid()) {
      return true;
    } else {
      return false;
    }
  }

  const saveURL = mainEl.data("save-url");  
  const dockDetailsPageUrl = mainEl.data("dock-details-url");

  let els = {};

  let elsModal = {};

  let removeDockModal, submitDocConfigModalFlow;
  let toggleForClosure=1;

  const doorDetailsArray=[];

  let monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const dockConfiguration = mainEl.data('dock-configuration-json');
  
  let elementsMap = {
    addShiftBtn: '.add-shift-btn',
    dayShiftRow: '.day-shift-row',
    submitDockBtn: '.submit-dock-btn',
    submitEditDockBtn: '.submit-edit-dock-btn',
    cancelDockBtn: '.cancel-dock-btn',
    
    dayOfWeekCheckbox: '.day-of-week-checkbox',
    addDoorBtn:'.add-door-btn',
    removeDockBtn: '.remove-dock-btn',
    //saveDockConfigBtn: '.save-dock-config-btn',
    removeDockHtmlSec :'.dock-details',
    cancelEditDockBtn:'.cancel-edit-dock-btn',
    dockDetailsFormElement:'#dock-details-form-element',
    addDateBtn :'.add-date-btn',
    addNewFacilityDockBtn:"#add-new-facility-dock-btn"
  }

  const elsModalMap = {
    removeDockDialogBtn: '.remove-btn-on-modal'
  };
  let dockConfigsToSave={
    dockDetails:[],
    plannedOperationClosures:{},
    history:{}
  };
  let shiftTimes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }
  let toggle=1;
  let initialized = false;
  let numberOfPlannedClosureDates=0;
  let savedShiftTimes = {
    //Sample data for saved shift times
    monday: [],
   // monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }
function init() {
  setElement();
  generateModals();
  setElementsOnModal();
  bindElement();
  initiateTimePickers();
  initiateDoorAppointmentType();
  handleSwitchingTypeInput();
}
function initiateDoorAppointmentType(){
  instantiateSelect2(mainEl.find('.select2-select'));
}
function setElement() {
  setElementsFromScope(els, elementsMap, mainEl);
}
function setElementsOnModal() {
    const $body = $('body');
    setElementsFromScope(elsModal, elsModalMap, $body);
  }
  function unbindElement() {
    mainEl.off('click', '.add-shift-btn');
    mainEl.off('click', '.remove-shift-btn');
    mainEl.off('click', '.cancel-dock-config-btn');
    mainEl.off('click', '.remove-dock-btn');
    mainEl.off('click', '.remove-door-btn');
    mainEl.off('click','.edit-dock-btn');
    mainEl.off('click','.add-date-btn');
    mainEl.off('click','.save-dock-config-btn');
  }
function bindElement() {
    unbindElement();
  mainEl.on('click', '.add-shift-btn', onAddShiftBtnClick);
  mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
  mainEl.on('click', '.cancel-dock-config-btn', onCancelDockBtnClick);
  mainEl.on('click', '.cancel-edit-config-btn', onCancelEditConfigBtnClick);
  els.submitDockBtn.on('click', onSubmitBtnClick);
  els.submitEditDockBtn.on('click', onEditSubmitBtnClick);
  els.cancelDockBtn.on('click', onCancelBtnClick);
  els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
  els.addDoorBtn.on('click', onAddDoorBtnClick);
  mainEl.on('click', '.remove-dock-btn', onRemoveDockbtnClick);
  //els.saveDockConfigBtn.on('click', onSaveDockConfigBtnClick);
  mainEl.on('click', '.remove-door-btn', onRemoveDoorBtnClick);
  mainEl.on('click', '.remove-date-btn', onRemoveDateBtnClick);
  elsModal.removeDockDialogBtn.on('click', removeDockModalFunc);
  mainEl.on('click','.edit-dock-btn',onEditDockBtnClick);
  mainEl.on('click','.save-dock-config-btn',onSaveBtnClick);
  els.cancelEditDockBtn.on('click', onCancelEditDockBtnClick);
  mainEl.on('click', '.add-date-btn', addDateBtnClick);
  
}


function onCancelDockBtnClick(){
   $('#edit-dock-details').show();
   $('#dock-config-new-edit').hide();
}

function generateModals(){
    removeDockModal = $(render(
      modalHtml,{
        title: 'Dock Removal',
        leftAlignTitle: true,
        modalDialogClass: 'q-modal-dialog-500',
        topCloseBtn: true,
        autoHideTop: true,
        body: ` <div class="q-marg-all-xl">
                  Are you sure you want to remove the dock from the facility?
                </div>`,
        footerBtns: `
                    <a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a>
                    <a href="#" class="base-btn purple-btn remove-btn-on-modal">Remove</a>
                    `
      }
    ));

    $('body').append(removeDockModal);

    submitDocConfigModalFlow = new SubmitModalFlow({
      confirmModalTile: 'Submit Dock Information',
      confirmModalBody: ` <div class="q-marg-all-xl">
                            Once submitted, the information provided will be 
                            used to accurately display available appointment 
                            slots for dock scheduling.
                          </div>`,
      confirmModalBtnText: 'Submit',
      modalDialogClass: 'q-modal-dialog-500',
      onConfirmClick: function(){
        submitDocConfigModalFlow.showLoadingModal();
        setTimeout(()=>{
          submitDocConfigModalFlow.showSuccessModal();
        }, 3000);
        setTimeout(()=>{
          submitDocConfigModalFlow.showFailureModal();
        }, 6000);
        setTimeout(()=>{
          submitDocConfigModalFlow.hideAllModals();
        }, 9000);
      }
    });

    submitDocConfigModalFlow.init();
  }

  let removeIndex;
  function onRemoveDockbtnClick(e){
    e.preventDefault();
    removeIndex = $(this).closest('.remove-dock-btn').data('index-id');
    removeDockModal.modal('show');
    
  }

  function removeDockModalFunc(){
    const removeDockHtml = $('.dock-details-'+removeIndex);
    removeDockHtml.remove();
    removeDockModal.modal('hide');
  }
function fillEditForm(dockeditformarea,docDetails){
  dockeditformarea.find("[name='dock-edit-name']").val(docDetails.dockName);
  var door = docDetails.doorDetails[0];
  dockeditformarea.find("[name='door-edit-name']").val(door.doorName);
  dockeditformarea.find("[name='door-edit-uses']").val(door.doorUses);
  dockeditformarea.find("[name='door-edit-appointment-types']").val(door.doorAppts);
 
  dockeditformarea.show();

}
function onEditDockBtnClick(e){
  e.preventDefault();
  
  $('#dock-config-new-edit').hide();
    var docDetails;
    let editDockIndex = $(this).closest('.edit-dock-btn').data('index-id');
    console.log("dockDetailsArray "+dockConfigsToSave.dockDetails.length);

    for (var i = 1; i <= dockConfigsToSave.dockDetails.length; i++) {
        if(i==editDockIndex)
        docDetails=dockConfigsToSave.dockDetails[i-1];
    //console.log("dockDetailsArray111 "+JSON.stringify(dockConfigsToSave.dockDetails[i-1]));
    //Do something
      }
console.log("docDet.dockDetails.dockName "+docDetails.dockName);
var dockeditformarea = $('#dock-details').find('#edit-dock-area');
if(dockeditformarea.length) {
  fillEditForm(dockeditformarea,docDetails);
  return;
}
    
    
  
    const dockName=docDetails.dockName;
     
    const doorEditHtml = require('./html/dockNewEdit/html/doorEdit.html');
    const dayShiftRow = require('./html/dockNewEdit/html/dayShiftRow.html');
    
    const doorsHtml = render(doorEditHtml, {
    ...docDetails.doorDetails[0]
  });
   
       
    const mainHtml = render(
      dockEditHtml, {
        dockName:dockName,
        doorEditDetails:doorsHtml,
       shiftEditRows: renderShiftRows(),
       dataEditIndex:editDockIndex
      });
    
    $('#dock-details').append(mainHtml);
    
    $('#door-edit-details-section').find('[name=door-edit-uses]').val(docDetails.doorDetails[0].doorUses);
    $('#door-edit-details-section').find('[name=door-edit-appointment-types]').val(docDetails.doorDetails[0].doorAppts);
   // instantiateSwitchery($('.js-switchery'));
    
    init();
    
    
    fillEditTimes(docDetails.dosDays);

 }

 function fillEditTimes(dosDays){
  const dayshiftrows =  $('#edit-dock-area').find('.day-shift-row');
  for(var i=0;i<6;i++){
    if(!(typeof dosDays[i].dosTime[0] === 'undefined')){
    if(dosDays[i].dosTime[0].dosStartTime !=null){
      const dayshiftrow=$(dayshiftrows[i]);
      dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
      dayshiftrow.trigger( "change" );
      const timePickerArea =  dayshiftrow.find('.time-picker-area');
      const dayOfWeek = timePickerArea.data('day-of-week');
      const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
      timeFrom.enableTimePicker();
      timeFrom.setTimeFromMilitary(dosDays[i].dosTime[0].dosStartTime);
      const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
      timeTo.enableTimePicker();
      timeTo.setTimeFromMilitary(dosDays[i].dosTime[0].dosEndTime);
      dayshiftrow.find('.add-shift-btn').removeClass('disabled');
      dayshiftrow.find('.default-add-shift-btn').show();
      dayshiftrow.find('.q-alert').hide();
    }
    if(dosDays[i].dosTime.length>1){
      for(var j=1; j<dosDays[i].dosTime.length;j++){
        if(dosDays[i].dosTime[j].dosStartTime !=null && dosDays[i].dosTime[j].dosStartTime != undefined){
          const dayshiftrow=$(dayshiftrows[i]);
          dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
          dayshiftrow.trigger( "change" );
          const timePickerAreaShift =  dayshiftrow.find('.time-picker-area');
          const dayOfWeek = timePickerAreaShift.data('day-of-week');
          const $newShiftHtml = $(newShiftHtml);
          const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
          timeFrom.enableTimePicker();
          timeFrom.setTimeFromMilitary(dosDays[i].dosTime[j].dosStartTime);
          const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
          timeTo.enableTimePicker();
          timeTo.setTimeFromMilitary(dosDays[i].dosTime[j].dosEndTime);
          timePickerAreaShift.append($newShiftHtml);
          shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
          if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {		
            timePickerAreaShift.find('.add-shift-btn').removeClass('disabled');
            timePickerAreaShift.find('.default-add-shift-btn').hide();
            let dayShiftRow = $(this).closest('.day-shift-row');
            dayShiftRow.find('.q-alert').hide();
          }
            if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 25) {
              timePickerAreaShift.find('.add-shift-btn').hide();
            }
        }
      }
    }
  }
  }
 }

  function onSaveDockConfigBtnClick(e){
    e.preventDefault();
    submitDocConfigModalFlow.showConfirmModal();
  }


  // let timePickerFromEl = mainEl.find('.time-picker-from');
  // let timePickerToEl = mainEl.find('.time-picker-to');
  
  // let timePickerFrom = timePicker(timePickerFromEl);
  // let timePickerTo = timePicker(timePickerToEl);


function onAddDoorBtnClick(e){
  e.preventDefault();
  let dockIndex;
  dockIndex = $(this).closest('.new-dock-form').data('index-id');
  const dockAreaFormEle = mainEl.find('#new-dock-form-'+dockIndex);
  const isValidOrgForm = validateForm(dockAreaFormEle);
  
  if(isValidOrgForm){
  const $newAddDoorHtml = $(newAddDoorHtml);  
  instantiateSelect2($newAddDoorHtml.find('.select2-select'));
  $('.add-door-details').append($newAddDoorHtml);
  } 
}

function onRemoveDoorBtnClick(e){
  e.preventDefault();
  const removeDoorHtml = $(this).closest('.remove-door-details');
  removeDoorHtml.remove();
}

	function onRemoveDateBtnClick(e){
  e.preventDefault();
  const removeDateHtml = $(this).closest('.remove-date-details');
  removeDateHtml.remove();
  //var closureDates= getClosureDates(dockConfiguration.plannedOperationClosures.closureDates);
  numberOfPlannedClosureDates--;
  if(numberOfPlannedClosureDates==0){
    $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").show();
  }
  // if(closureDates.length==0){
  //   $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").show();
  // }
  }

  function nthDay(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

		

function addDateBtnClick(e) {
e.preventDefault();
  const closureDateHtml = require('./html/dockConfigNewEdit/html/closureDates.html'); 
  const plannedClosures = $("#planned-closure-details");
  let plannedClosureDate= plannedClosures.find("input[name='add-date-text']").val();
  var date=new Date(plannedClosureDate);
  let dateTextToShow = `${monthArr[date.getMonth()]} ${date.getDate()}${nthDay(date.getDate())}, ${date.getFullYear()} :`;
  const closurename="closure-date-"+toggleForClosure;
  const closureDt = render(
    closureDateHtml, {
      plannedClosureDate:dateTextToShow,
      closureDate:closurename,
      toggleForClosure:toggleForClosure
    }
  );
  toggleForClosure++;
  $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").hide();
  numberOfPlannedClosureDates++;
  $('#dock-config-new-edit').find("div[name='closure-details']").append(closureDt);
  instantiateSwitchery($('.js-switchery'));

  //const timePickerArea=$(closureDt).find('.time-picker-area');
  const timePickerArea=$('#dock-config-new-edit').find("."+closurename).find('.time-picker-area');
    const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
    const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
    timeFrom.enableTimePicker();
    timeTo.enableTimePicker();

  
  
}

function onAddShiftBtnClick(e) {
  e.preventDefault();
  const timePickerArea = $(this).closest('.time-picker-area');
  const dayOfWeek = timePickerArea.data('day-of-week');
  const $newShiftHtml = $(newShiftHtml);
  const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
  const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
  //const prevAddShiftBtn = timePickerArea.find('.add-shift-btn');
  

  shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
  const timeFromVal = timePicker(timePickerArea.find('.time-picker-from'));
  const timeToVal = timePicker(timePickerArea.find('.time-picker-to'));
  if(timeFromVal.getMilitaryTime(shiftTimes[dayOfWeek][0].timeFrom)!="Invalid date" && timeToVal.getMilitaryTime(shiftTimes[dayOfWeek][0].timeTo)!="Invalid date"){
    if(timeFromVal.getMilitaryTime(shiftTimes[dayOfWeek].timeFrom) < timeToVal.getMilitaryTime(shiftTimes[dayOfWeek].timeTo)){
    timePickerArea.append($newShiftHtml);
  if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
    
    timePickerArea.find('.add-shift-btn').removeClass('disabled');
    timePickerArea.find('.default-add-shift-btn').hide();
    let dayShiftRow = $(this).closest('.day-shift-row');
    //let dayOfWeekShift = dayShiftRow.data('day-of-week');
    dayShiftRow.find('.q-alert').hide();
  }
  if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 25) {
    timePickerArea.find('.add-shift-btn').hide();
  }
  $(this).hide();
}
  else{
    let dayShiftRow = $(this).closest('.day-shift-row');
    dayShiftRow.find('.q-alert-t').show();
  }
}
else{
  let dayShiftRow = $(this).closest('.day-shift-row');
  dayShiftRow.find('.q-alert').show();
}
}

function onRemoveShiftBtnClick(e) {
  e.preventDefault();
  const timePickerArea = $(this).closest('.time-picker-area');
  const dayOfWeek = timePickerArea.data('day-of-week');
  const shiftToRemove = $(this).closest('.new-shift');
  const indexToRemove = shiftToRemove.index();
  const prevAddShift = $(timePickerArea.find('.new-shift').get(indexToRemove-2)).find('.add-shift-btn');
  $(shiftToRemove).remove();
  shiftTimes[dayOfWeek].splice(indexToRemove, 1);
  if (shiftTimes[dayOfWeek].length < 25) {
    timePickerArea.find('.add-shift-btn').removeClass('disabled');
  }
  if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
    //timePickerArea.find('.add-shift-btn').show();
    prevAddShift.show();
    timePickerArea.find('.default-add-shift-btn').hide();
  }
  if (shiftTimes[dayOfWeek].length == 1 ) {
    timePickerArea.find('.default-add-shift-btn').show();
  }
}


  //validator = mainEl.validate(validationOpts);
  //validator.settings.ignore = ":disabled,:hidden";
  function onSaveBtnClick(e){
    console.log(dockConfigsToSave);

    const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Save Dock Configuration",
        confirmModalBody: '<div class="q-pad-all-xl">Once saved this dock scheduled warehouse dock Configuration are assigned to this warehouse.</div>',
        confirmModalBtnText: "Save",
        onConfirmClick: function () {
          let saveDockConfigURL = saveDockURL;
          submitModalFlow.showLoadingModal();
          $.ajax({
            data: 
            {
            dockConfiguration: JSON.stringify(dockConfigsToSave)
          },
            url: saveDockConfigURL,
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
              EditChecker.setPageClean();
              submitModalFlow.hideAllModals();
              submitModalFlow.showSuccessModal();
              setTimeout(function () {
                 location.href = dockDetailsPageUrl;// + "&retailerId=" + data;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            },
            error: function (data) {
              submitModalFlow.hideAllModals();
              submitModalFlow.showFailureModal();
            }
          });
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
  }
function timeConverter(miltaryTime){
  if(miltaryTime == "Invalid date") return miltaryTime;
  var hourAndMinute = miltaryTime.split(":");
  var hours = hourAndMinute[0],minutes=hourAndMinute[1];
  var AmOrPm = hours >= 12 ? 'PM' : 'AM';
  hours = (hours % 12) || 12;
  return hours + ":" + minutes + " " + AmOrPm;
}

function onEditSubmitBtnClick(e){
  let editDockIndex;
  editDockIndex = $(this).closest('.edit-dock-form').data('edit-index-id');
  const editDockAreaFormEle = mainEl.find('#edit-dock-form-'+editDockIndex);
  const isValideditDockForm = validateForm(editDockAreaFormEle);
  if(isValideditDockForm){
  var editDockArea =$('#edit-dock-area');
  var editIndex = editDockArea.data('edit-index');
  //const dockAreaFormEle  = mainEl.find('#edit-dock-form-'+editIndex);
  var newDockName = editDockArea.find("input[name='dock-edit-name']").val();
  var newDoorName = editDockArea.find("input[name='door-edit-name']").val();
  var newDoorUses = editDockArea.find("select[name='door-edit-uses']").val();
  var newDoorApptTypes = editDockArea.find("select[name='door-edit-appointment-types']").val();

  var newDosDays = getShiftTimes();
  
  dockConfigsToSave.dockDetails[editIndex-1] = {
    dockName:newDockName,
    doorDetails:[{doorName:newDoorName,doorUses:newDoorUses,doorAppts:newDoorApptTypes}],
    dosDays: newDosDays.dosDays
    };
  var docDisplayDetails = $('#docDisplayDetails-'+editIndex);
  docDisplayDetails.find('[name=dock-name]').text(newDockName);
  docDisplayDetails.find('[name=doordetails-doorname]').text(newDoorName);
  docDisplayDetails.find('[name=doordetails-dooruses]').text(newDoorUses);
  docDisplayDetails.find('[name=doordetails-doorappts]').text(newDoorApptTypes);
  docDisplayDetails.find('[name=operational-shift-times-summary]').remove();
  docDisplayDetails.find('[name=operational-times-area]').append(renderoptimes(newDosDays.shiftTimesToSave));
  editDockArea.hide();
  $('#dock-config-new-edit').show();
}
}
function onSubmitBtnClick(e) {
  e.preventDefault();
  let dockIndex;
  dockIndex = $(this).closest('.new-dock-form').data('index-id');
  const dockAreaFormEle = mainEl.find('#new-dock-form-'+dockIndex);
  const isValidOrgForm = validateForm(dockAreaFormEle);
  if(isValidOrgForm){
  
  
  const dock = $("#new-edit-dock-area");
  const dockNewEditHtml =dock.find( "div[name='door-details-section']");
  const dockName= dock.find("input[name='dock-name']").val();
  
  var i;
  const doorDetailsArray=[];
for (i = 0; i < dockNewEditHtml.length; i++) { 
  var door = $(dockNewEditHtml.get(i));
  const doorDetails ={};
  doorDetails.doorName = door.find("input[name=door-name]").val();
  doorDetails.doorUses = door.find("select[name=door-uses]").val();
  doorDetails.doorAppts = door.find("select[name=door-appointment-types]").val();
  doorDetailsArray[i] =doorDetails; 
}

var shiftTimes = getShiftTimes();
dockConfigsToSave.dockDetails.push({
  dockName:dockName,
  doorDetails:doorDetailsArray,
  dosDays: shiftTimes.dosDays
  });

  // const doorDetailsSection = dockNewEditHtml;

  // doorDetailsSection.each( obj, function( index, value ) {
  //   console.log( index + ": " + value );
  // });
 
  addSubmittedDocks(dockName, doorDetailsArray, shiftTimes.shiftTimesToSave);
  onCancelBtnClick(e);
}
}

function getShiftTimes(){
  const shiftTimesToSave = {};

  Object.keys(shiftTimes).forEach((key) => {
    shiftTimesToSave[key] = shiftTimes[key].map((el) => {
      return {
        from: timeConverter(el.timeFrom.getMilitaryTime()),
        to: timeConverter(el.timeTo.getMilitaryTime()),
        fromTime: el.timeFrom.getMilitaryTime(),
        toTime: el.timeTo.getMilitaryTime()
      }
    });
  });
  
  var dosDays=[],p=0;
  Object.keys(shiftTimesToSave).forEach((key) => {
    dosDays[p]={};
    dosDays[p].dosDay = key;
    dosDays[p].dosTime =[];
    dosDays[p].dosTime = shiftTimesToSave[key].map((el) => {
      if(el.from != "Invalid date"){
        return {dosStartTime: el.fromTime,dosEndTime: el.toTime}
      }
      });
    p++;
  });
  return {dosDays:dosDays,shiftTimesToSave:shiftTimesToSave};
}
function addSubmittedDocks(dockName, doorDetailsArray, shiftTimesToSave){
  let toggleDoor=1;
  const mydoorsHtml = require('./html/dockNewEdit/html/mydoorsummary.html');
  const doordetailsHtml = require('./html/dockNewEdit/html/doordetails.html');
 

  const doorrows = doorDetailsArray.map((doorDetails) => {
  
    return render(doordetailsHtml, {
      doorDetails,
      toggle:toggleDoor++
    });
  });
toggleDoor=1;
  const a=doorrows.join('');

  

  const opdiv=renderoptimes(shiftTimesToSave);
 
  const mydoors = render(
    mydoorsHtml, {
      dockName: dockName,
      doordetailshtml: a,
      timehtml:opdiv,
      togglerTarget:"toggler-target-"+toggle,
      dockDetails:"dock-details-"+toggle,
      toggle:toggle
    }
  );
  toggle++;
  $('#dock-config-new-edit').find("div[name='dock-details-area']").append(mydoors);
 // $('#dock-config-new-edit').find("div[name='operational-times-area']").append(optimes);
 $('#dock-config-new-edit').find("div[name='add-facility-dock-btn-section']").hide();
 $('#dock-config-new-edit').find("div[name='add-new-facility-dock-btn']").show();
 

}

function renderoptimes(shiftTimesToSave){
  const optimes=[],optimeIndex=0;
  let toggleshift=1;
  const opertionalshifttimesHtml = require('./html/dockNewEdit/html/opertionalshifttimes.html');
  
  Object.keys(shiftTimesToSave).forEach((key) => {
    
    var mytimes=shiftTimesToSave[key].map((el) => {
      if(el.from=='Invalid date') return;
      return '<span id="edit-operational-shift-{%-toggleshift%}">'+el.from +' - '+el.to +'</span> <br />';
     
      }
      
    );
    if(mytimes.length>0)
    optimes.push(render(opertionalshifttimesHtml,
       {
        day: key,
        time: mytimes.join('')
       })
       
    );
    toggleshift++;
   // shiftTimesToSave[key]=[];
  });

  return optimes.join('');
}
function onCancelBtnClick(e) {
  e.preventDefault();
  Object.keys(shiftTimes).forEach((key) => {
  shiftTimes[key]=[];
     });
  const newEditDockArea = $('.new-dock-form');
  newEditDockArea.remove();
  $('#dock-config-new-edit').show();
  
}

function onCancelEditConfigBtnClick(e) {
  const newEditDockArea = $('#dock-config-new-edit');
  newEditDockArea.remove();
  $('#edit-dock-details').show();
}

  function onCancelEditDockBtnClick(e){
    e.preventDefault();
    Object.keys(shiftTimes).forEach((key) => {
      shiftTimes[key]=[];
      
    });
    
    const editDockArea = $('#edit-dock-area');
    editDockArea.remove();
    $('#dock-config-new-edit').show();
  }
  
function initiateDatePickers() {
const plannedClosures = $("#planned-closure-details");
let plannedClosureDate= plannedClosures.find("input[name='add-date-text']");
	  const today = new Date();
   plannedClosureDate.datepicker({
      startDate: today,
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });
   
}

function initiateTimePickers() {
  els.dayShiftRow.each((index, el) => {
    const $el = $(el);
    const dayOfWeek = $el.data('day-of-week');
    const timePickerArea = $el.find('.time-picker-area');
    const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
    const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
    const dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
    timeFrom.disableTimePicker();
    timeTo.disableTimePicker();
    shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
    if (savedShiftTimes[dayOfWeek].length == 1) {
      dayOfWeekCheckbox.prop('checked', 'true');
      timePickerArea.find('.add-shift-btn').removeClass('disabled');
      timeFrom.enableTimePicker();
      timeTo.enableTimePicker();
      timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
      timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
    } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
      dayOfWeekCheckbox.prop('checked', 'true');
      timePickerArea.find('.add-shift-btn').removeClass('disabled');
      timeFrom.enableTimePicker();
      timeTo.enableTimePicker();
      timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
      timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
      savedShiftTimes[dayOfWeek].shift();
      savedShiftTimes[dayOfWeek].map((shift) => {
        const $newShiftHtml = $(newShiftHtml);
        const timeFrom = timePicker($newShiftHtml.find('.time-picker-from'));
        const timeTo = timePicker($newShiftHtml.find('.time-picker-to'));
        timePickerArea.append($newShiftHtml);
        timeFrom.setTimeFromMilitary(shift.from);
        timeTo.setTimeFromMilitary(shift.to);
        shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
      });
    }
    if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
      timePickerArea.find('.add-shift-btn').addClass('disabled');
    }
  });
}
function handleCheckboxChange() {
  let isChecked = $(this).is(':checked');
  let dayShiftRow = $(this).closest('.day-shift-row');
  let dayOfWeek = dayShiftRow.data('day-of-week');
  if (isChecked) {
    shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
    shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
    dayShiftRow.find('.add-shift-btn').removeClass('disabled');
    dayShiftRow.find('.default-add-shift-btn').show();
  } else {
    dayShiftRow.find('.new-shift').remove();
    shiftTimes[dayOfWeek].length = 1;
    shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
    shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
    shiftTimes[dayOfWeek][0].timeFrom.resetTime();
    shiftTimes[dayOfWeek][0].timeTo.resetTime();
    dayShiftRow.find('.add-shift-btn').addClass('disabled');
    dayShiftRow.find('.default-add-shift-btn').show();
  }
}

//const editDockBtn = mainEl.data('data-edit-dock-url');
const saveDockURL = mainEl.data('save-dock-url');

mainEl.on("click", '.edit-dock-configurations-purple-btn', editDockHandler);
mainEl.on("click", '.add-facility-dock-btn', addFacilityDockHandler);
mainEl.on("click", '#add-new-facility-dock-btn', addFacilityDockHandler);

const dockConfigNewEditHtml = require('./html/dockConfigNewEdit/html/dockConfigNewEdit.html');
const dockNewEditHtml = require('./html/dockNewEdit/html/dockNewEdit.html');


// function editDockHandler(e){
//   e.preventDefault();
//   $('#edit-dock-details').hide();
//   const dockConfigNewEdit = $(render(dockConfigNewEditHtml, {
//         facilityDocks: require('./html/dockConfigNewEdit/html/facilityDocks.html'),
//         plannedOperationClosure: require('./html/dockConfigNewEdit/html/plannedOperationClosure.html')
//   }));

//   $('#dock-details').append(dockConfigNewEdit);
//   }

function addFacilityDockHandler(e){
  e.preventDefault();
  $('#dock-config-new-edit').hide();
  // const dockNewEdit = $(render(dockNewEditHtml, {
  //    day:"Monday",
  //       shiftRows: require('./html/dockNewEdit/html/dayShiftRow.html')
       
  // }));
  const mainHtml1 = render(
    dockNewEditHtml, {
      shiftRows: renderShiftRows(),
      toggle
    }
  );
  $('#dock-details').append(mainHtml1);
  instantiateSelect2($('.new-dock-form').find('.select2-select'));
  $('.new-dock-form').find('.doorUses').on("change", handleDoorUsesChange);
  init();
  
   }

   function handleDoorUsesChange(){
    handleSwitchingTypeInput();
  }
  
  function handleSwitchingTypeInput(){
    let doorUsesVal = $('.doorUses  :selected').val();
    if (doorUsesVal == "Inbound and Outbound"){
      renderapmtTypeIAO(doorUsesVal);
    }
    else{
      renderapmtTypeIAO(doorUsesVal);
    }
  }
  
  let aptTypesIAO = [
    {
      key:'Live Load',
      value:'Live Load'
    },
    {
      Key:'Pickup Empty',
      value:'Pickup Empty'
    },
    {
      key:'Pickup Load',
      value:'Pickup Load'
    },
    {
      key:'Live Unload',
      value:'Live Unload'
    },
    {
      key:'Drop Unload',
      value:'Drop Unload'
    },
    {
      key:'Drop Load',
      value:'Drop Load'
    }
    ];
  
  let aptTypesO = [
    {
      key:'Live Load',
     value:'Live Load'
    },
    {
      Key:'Pickup Empty',
      value:'Pickup Empty'
    },
    {
      key:'Pickup Load',
      value:'Pickup Load'
    }
    ];
  
  let doorUses={
    'Inbound and Outbound' : 'Inbound and Outbound',
    'Outbound only' : 'Outbound only'
  };
  
  function renderapmtTypeIAO(doorUsesVal){
    const aptTypeSelect = $(".doorAppointmentTypes");
     aptTypeSelect.html('');
      if (doorUsesVal == "Inbound and Outbound") {
        $(aptTypesIAO).each(function () {
          let option = $('<option />');
          option.attr('value', this.key).text(this.value);
          aptTypeSelect.append(option);
        });
      }
      else if (doorUsesVal == "Outbound only") {
        $(aptTypesO).each(function () {
          let option = $('<option />');
          option.attr('value', this.key).text(this.value);
          aptTypeSelect.append(option);
        });
      }
      aptTypeSelect.addClass("select2 select");
      instantiateSelect2(aptTypeSelect);
  }

function editDockHandler(e){
  e.preventDefault();
  $('#edit-dock-details').hide();
  const dockConfigNewEdit = $(render(dockConfigNewEditHtml, {
        facilityDocks: render(require('./html/dockConfigNewEdit/html/facilityDocks.html'),
        {
            dockTypes: getRenderedDockTypes(dockConfiguration.dockDetails),
        }),
        plannedOperationClosure: render(require('./html/dockConfigNewEdit/html/plannedOperationClosure.html'),
        {
        closureDates: getClosureDates(dockConfiguration.plannedOperationClosures.closureDates),
        }),
  }));
  dockConfigNewEdit.find('#add-new-facility-dock-btn').hide();
  $('#dock-details').append(dockConfigNewEdit);
  instantiateSelect2($('.edit-dock-form').find('.select2-select'));
  $('.edit-dock-form').find('.editDoorUses').on("change", handleDoorUsesChange);
  initiateDatePickers();
  }

   function renderShiftRows() {
    let days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    //let days = ['Monday', 'Tuesday'];
    const dayShiftRowHtml = require('./html/dockNewEdit/html/dayShiftRow.html');
    //const rawTemplateHtml = require('./html/timePickerTemplate.html');
    const shiftRow = days.map((day) => {
      return render(dayShiftRowHtml, {
        day
      });
    });

    return shiftRow.join('');
  }

  //Iterating JSON data
  function getRenderedDockTypes(dockTypes) {
      const dockTypeHtml = require("./html/dockConfigNewEdit/html/multipledocks.html");
       const response = _.map(dockTypes, (docks) => {
        return render(dockTypeHtml, {
          docks: docks,
          dosDays:getDosDays(docks.dosDays),
          doorDetails:getDoorDetails(docks.doorDetails),
        });
      });
      return response.join(""); 
    }
    function getDosDays(dosDays) {
      const dosDaysHtml = require("./html/dockConfigNewEdit/html/dockShiftDays.html");
       const response = _.map(dosDays, (dosDay) => {
        return render(dosDaysHtml, {
          dosDay: dosDay,
          dosTimes:getDosTimes(dosDay.dosTime),
        });
      });
      return response.join(""); 
    }
    function getDosTimes(dosTimes) {
      const dosTimesHtml = require("./html/dockConfigNewEdit/html/dockShiftTime.html");
       const response = _.map(dosTimes, (dosTime) => {
        return render(dosTimesHtml, {
          dosTime: dosTime,
        });
      });
      return response.join(""); 
    }
    function getDoorDetails(doorDetails) {
      const doorDetailsHtml = require("./html/dockConfigNewEdit/html/doorDetailsForm.html");
       const response = _.map(doorDetails, (doorDetail) => {
        return render(doorDetailsHtml, {
          doorDetail: doorDetail,
        });
      });
      return response.join(""); 
    }

    function getClosureDates(closureDates) {
      if(!closureDates) return [];
      const closureDatesHtml = require("./html/dockConfigNewEdit/html/closureDates.html");
       const response = _.map(closureDates, (closureDate) => {
        return render(closureDatesHtml, {
          closureDate: closureDate,
          closureDate:"closure-date-"+toggleForClosure,
          toggleForClosure:toggleForClosure
        });
        toggleForClosure++;
      });
      return response.join(""); 
    }




     $('#deactivate-dock-btn-details').on("click", function(e) {  
        let deactivateDockModal = new SubmitModalFlow({
            confirmModalTitle: deactivateDock,
            confirmModalBody: deactivateDiv,
            confirmModalBtnText: deactivateDockBtn,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {

                deactivateDockModal.showLoadingModal();
                    deactivateDock({url: deleteItemUrl, success: deactivateSuccess, error: deactivateFailure});
                    function deactivateDock({url, success, error}){
                        $.ajax({
                            data:  {
                                docId: dockId,
                                activeDeativeFlag: "N"
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function deactivateSuccess(){
                        deactivateDockModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                         }, 3000);
                    }
                    function deactivateFailure(){
                        deactivateDockModal.showFailureModal();
                    }
                }
          });
          deactivateDockModal.init();
          deactivateDockModal.showConfirmModal();
    });
   
    
    $('#activate-dock-btn-details').on("click", function(e) { 
        e.preventDefault();  
        let activateDockModal = new SubmitModalFlow({
            confirmModalTitle: activateDock,
            confirmModalBody: activateDiv,
            confirmModalBtnText: activateDockBtn,
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function() {
               
                    activateDockModal.showLoadingModal();
                    activateDock({url: deleteItemUrl, success: activateSuccess, error: activateFailure});
                    function activateDock({url, success, error}){
                        $.ajax({
                            data:  {
                                docId: dockId,
                                activeDeativeFlag: "Y"
                              },
                            url: url,
                            dataType:"JSON",
                            type: 'POST',
                            success: success,
                            error: error
                        });
                    }
                    function activateSuccess(){
                        activateDockModal.showSuccessModal();
                        setTimeout(function() {
                            location.href=pageRefreshUrl;
                         }, 3000);
                    }
                    function activateFailure(){
                     activateDockModal.showFailureModal();   
                    }
                }
          });
          activateDockModal.init();
          activateDockModal.showConfirmModal();
    });
//END Iterating JSON data

  
//   function onEditDockBtnClick(e){
//   e.preventDefault();
//   const editDockHtml = $(this).closest('.remove-door-details');
//   editDockHtml.remove();
// }

init();

}









// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/dockConfigDetails.js